import { Component, ViewChild, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UsuarioService } from '../../../services/usuario.service';
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from 'ngx-toastr';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AngularFireDatabase } from "@angular/fire/database";
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';


@Component({
    selector: 'app-tipo-impressao',
    templateUrl: './remover-produtos-dialog.html',
    styleUrls: ['./remover-produtos-dialog.scss', '../../../styles/estilo.padrao.scss']
})
export class RemoverProdutoDialog {
    bAutenticado: boolean = false;
    senhaMaster: string;

    uid;

    copiaProdutos;
    copiaTotal: number;
    produtosSource;
    auxValorTotal: number;
    displayedColumns: string[] = ['Codigo', 'Nome', 'Valor', 'SubtrairQuantidade', 'RemoverProduto'];
    produtosLista: any[] = [];
    bEstornarEstoque: string = 'true';
    gruposPromocionaisAtivosCompra: any = [];

    @ViewChild(MatPaginator) paginator: MatPaginator;

    constructor(
        private dialogRef: MatDialogRef<RemoverProdutoDialog>,
        private usuarioService: UsuarioService,
        private spinner: NgxSpinnerService,
        private toastr: ToastrService,
        private db: AngularFireDatabase,
        private router: Router,
        @Inject(MAT_DIALOG_DATA) public data: { produtos: any, total: number, idPedido: any }

    ) {
        this.uid = localStorage.getItem('uid');

        console.log(this.data.produtos)

        try {
            this.usuarioService.getGruposPromocoes().pipe(take(1)).subscribe(snap => {

                if (snap.length > 0) {
                    let dados;
                    snap.forEach((item, index) => {
                        dados = item.payload.val();
                        for (let i = 0; i < this.data.produtos.length; i++) {
                            if (this.data.produtos[i].IDGrupoPromocional === item.key && (this.gruposPromocionaisAtivosCompra.findIndex(x => x.ID === item.key) === -1)) {
                                this.gruposPromocionaisAtivosCompra.push({
                                    ID: item.key,
                                    Status: dados.Status,
                                    Nome: dados.Nome,
                                    Produtos: dados.Produtos,
                                    QuantidadeMinima: dados.QuantidadeMinima,
                                    PorcentagemDesconto: this.data.produtos[i].PorcentagemDesconto
                                });
                            }
                        }
                    });
                }
            });
        }
        catch (e) {
            this.toastr.error('Houve um erro ao recuperar os grupos promocionais. Por favor atualize a página e tente novamente mais tarde!', 'Status', { progressBar: true, positionClass: 'toast-top-center', });

            setTimeout(() => {
                this.spinner.hide('default');
                this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
                    this.router.navigate(["/pages/consultar-pedidos"], { queryParams: { numeroPedido: this.data.idPedido } }));
            }, 500);
        }
    }

    removerProduto(produto) {
        const index = this.produtosLista.findIndex(x => x.Key === produto.Key);

        if (index !== -1) {
            if (this.produtosLista.length >= 2) {
                let auxProdutos = this.produtosLista;
                // this.auxValorTotal -= (auxProdutos[index].ValorFloat * auxProdutos[index].QuantidadeComprada);
                auxProdutos.splice(index, 1);
                this.verificarProdutosPromocionais(auxProdutos);
                // this.produtosLista = auxProdutos;
                // this.produtosSource = new MatTableDataSource(this.produtosLista);

            } else
                this.toastr.error('Não é possível remover todos os produtos de uma compra. Realize o cancelamento!', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
        }
    }

    adcRemoverUnidade(produto, b) {
        const index = this.produtosLista.findIndex(x => x.Key === produto.Key);
        if (index !== -1) {
            let auxProdutos = this.produtosLista;

            //Somar
            if (b) {
                auxProdutos[index].QuantidadeComprada += 1;
                // this.auxValorTotal += auxProdutos[index].ValorFloat;
                this.verificarProdutosPromocionais(auxProdutos);
            } else { //Subtrair
                if (auxProdutos[index].QuantidadeComprada - 1 >= 1) {
                    auxProdutos[index].QuantidadeComprada -= 1;
                    // this.auxValorTotal -= auxProdutos[index].ValorFloat;
                    this.verificarProdutosPromocionais(auxProdutos);
                } else
                    this.toastr.warning('Remova o produto da lista ao invés de zerar sua quantidade!', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
            }
            // this.produtosLista = auxProdutos;
        } else
            this.toastr.warning('Não foi possível alterar a quantidade do produto!', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
    }

    verificarProdutosPromocionais(auxProdutos) {

        //Aplica o desconto nos produtos do carrinho
        let auxGrupoPromocional;
        let auxDesconto;
        let auxValorX;

        let auxTotal = 0;
        for (let i = 0; i < auxProdutos.length; i++) {
            auxDesconto = this.validarDescontoGrupoProduto(auxProdutos[i], auxProdutos);
            auxGrupoPromocional = this.gruposPromocionaisAtivosCompra[this.gruposPromocionaisAtivosCompra.findIndex(x => x.ID === auxProdutos[i].IDGrupoPromocional)];
            if (auxDesconto) {
                auxValorX = (auxProdutos[i].ValorFloat - (auxProdutos[i].ValorFloat * (0.01 * auxDesconto))).toFixed(2);
                auxProdutos[i].PorcentagemDesconto = auxDesconto;
                auxProdutos[i].ValorRealDesconto = auxValorX.toString().substring(0, auxValorX.toString().indexOf("."));
                auxProdutos[i].ValorCentavosDesconto = auxValorX.toString().substring((auxValorX.toString().length - 2), auxValorX.length);
                auxProdutos[i].ValorDesconto = auxValorX;
                auxProdutos[i].NomeGrupoPromocional = auxGrupoPromocional.Nome;
                auxProdutos[i].IDGrupoPromocional = auxGrupoPromocional.ID;
                auxProdutos[i].DescontoGrupoPromocional = true;

                auxTotal += (auxValorX * auxProdutos[i].QuantidadeComprada);
            } else {
                auxProdutos[i].DescontoGrupoPromocional = false;

                // valorUnitarioComDesconto = (carrinho[i].Valor - (carrinho[i].Valor * (0.01 * descontoPromocional))).toFixed(2);
                auxTotal += (auxProdutos[i].ValorFloat * auxProdutos[i].QuantidadeComprada);
            }
        }

        console.log(auxProdutos)

        this.produtosLista = auxProdutos;

        this.produtosSource = new MatTableDataSource(this.produtosLista);

        this.auxValorTotal = auxTotal;
    }

    validarDescontoGrupoProduto(produto, carrinho) {
        let cont = 0;
        const index = this.gruposPromocionaisAtivosCompra.findIndex(x => x.ID === produto.IDGrupoPromocional);
        if (index !== -1) {
            if (carrinho.length > 0) {
                for (let i = 0; i < carrinho.length; i++) {
                    if (this.gruposPromocionaisAtivosCompra[index].Produtos.findIndex(x => x.ID === carrinho[i].Key) !== -1) {
                        cont += this.gruposPromocionaisAtivosCompra[index].Produtos.findIndex(x => x.ID === carrinho[i].Key) !== -1 ? (carrinho[i].QuantidadeComprada) : 0;
                    }
                }
            } else
                cont += produto.QuantidadeComprada; //Se o carrinho não estiver inicializado ou for o produto, colocar a quantidade comprada no cont.
        }

        if (index !== -1 && cont >= this.gruposPromocionaisAtivosCompra[index].QuantidadeMinima) {
            return this.gruposPromocionaisAtivosCompra[index].PorcentagemDesconto;
        } else
            return false
    }

    salvarAlteracoes() {

        this.spinner.show('default');

        const map = {
            ProdutosAntigos: this.copiaProdutos,
            NovosProdutos: this.produtosLista,
            TotalAntigo: this.copiaTotal,
            NovoTotal: this.auxValorTotal
        }


        this.usuarioService.setLogAlteracaoPedido("Alteração de produtos no pedido: " + this.data.idPedido, map, this.uid).then(resp => {
            this.finalizarAlteracaoPedido();
        }).catch(err => {
            this.usuarioService.setLogAlteracaoPedido("Erro ao produtos. Erro: " + err + " Pedido: " + this.data.idPedido, map, this.uid);

            this.toastr.error('Houve um erro ao tentar aplicar a alteração, atualize a págine e verifique se a alteração foi aplicada!', 'Status', { progressBar: true, positionClass: 'toast-top-center', });

            setTimeout(() => {
                this.spinner.hide('default');
                this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
                    this.router.navigate(["/pages/consultar-pedidos"], { queryParams: { numeroPedido: this.data.idPedido } }));
            }, 500);
        });
    }

    finalizarAlteracaoPedido() {

        this.dialogRef.close();

        let produtosEstornar = [];
        try {
            this.db.object('Clientes/' + this.uid + '/Pedidos/' + this.data.idPedido).query.ref.transaction(valor => {
                if (valor) {
                    let auxPts = valor.Produtos;
                    let arrayProdutosFinal = [];
                    let auxIndex;
                    let diferencaIncrementarDebitarEstoque;

                    for (let i = 0; i < valor.Produtos.length; i++) {
                        diferencaIncrementarDebitarEstoque = 0;
                        auxIndex = this.produtosLista.findIndex(x => x.Key === auxPts[i].Key);

                        if (auxIndex !== -1) {

                            diferencaIncrementarDebitarEstoque = this.produtosLista[auxIndex].QuantidadeComprada - auxPts[i].QuantidadeComprada;
                            //Aplica as alterações ou mantém o dado;
                            auxPts[i].QuantidadeComprada = this.produtosLista[auxIndex].QuantidadeComprada;
                            auxPts[i].DescontoGrupoPromocional = this.produtosLista[auxIndex].DescontoGrupoPromocional;

                            //Se a diferença for diferente de 0, ele irá incrementar ou subtrair;
                            if (diferencaIncrementarDebitarEstoque !== 0) {
                                produtosEstornar.push({ Key: auxPts[i].Key, Estornar: (diferencaIncrementarDebitarEstoque * -1) }); //Multiplico por -1 para Debitar quando for incrementar e Incrementar quando for subtraído da quantidade comprada;
                            }

                            arrayProdutosFinal.push(auxPts[i]);
                        } else {
                            produtosEstornar.push({ Key: auxPts[i].Key, Estornar: auxPts[i].QuantidadeComprada, DemaisDados: JSON.stringify(auxPts[i]) });
                        }
                    }

                    const auxValor = this.auxValorTotal.toFixed(2).replace('.', ',');
                    valor.Produtos = arrayProdutosFinal;
                    valor.Total = this.auxValorTotal;
                    valor.ValorRealString = auxValor.substring(0, auxValor.indexOf(","));
                    valor.ValorCentavosString = auxValor.substring((auxValor.length - 2));
                    return valor;
                }
                return valor;
            }).then(async resp => {

                if (this.bEstornarEstoque === 'true') {
                    // Pegar a diferença do estoque e estornar
                    this.toastr.warning('Estornando/Incrementando estoque dos produtos da compra...', 'Status', { progressBar: true, positionClass: 'toast-top-center', });

                    try {
                        await Promise.all(produtosEstornar.map(async (value) => {
                            const content = this.db.object('Clientes/' + this.uid + '/Produtos/' + value.Key).query.ref.transaction(produto => {

                                if (produto !== null) {
                                    produto.QuantidadeEstoque += value.Estornar;
                                    return produto;
                                }
                                return produto;
                            }).then(resp => {


                            }).catch(e => {
                                console.log(e)
                                this.spinner.hide('default');
                                this.usuarioService.setLogAlteracaoPedido("Erro ao atualizar " + value.Nome + " " + value.ID + ". Erro: " + e + " Pedido: " + this.data.idPedido, produtosEstornar, this.uid);

                                this.toastr.error('Erro ao atualizar ' + value.Nome + '. Aguardade até todo o procedimento e atualize a página para verificar se houve a alteração no estoque do produto.', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
                            });

                        })).then(resp => {

                            this.toastr.success('O estoque dos produtos foram alterados com sucesso!', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
                            this.usuarioService.setLogAlteracaoPedido("Alteração estoque alteração de produtos Pedido: " + this.data.idPedido, produtosEstornar, this.uid);

                            setTimeout(() => {
                                this.spinner.hide('default');
                                this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
                                    this.router.navigate(["/pages/consultar-pedidos"], { queryParams: { numeroPedido: this.data.idPedido } }));
                                this.toastr.clear();
                            }, 500);
                        });

                    } catch (e) {
                        console.log(e)
                        this.spinner.hide('default');
                        this.usuarioService.setLogEstoque("Erro ao atualizar estoque de produtos. Erro: " + e, this.produtosLista, this.uid);

                        this.toastr.error('Erro ao atualizar estoque de produtos! Atuelize a págine e verifique se o dado foi atualizado.', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
                        this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
                            this.router.navigate(["/pages/consultar-pedidos"], { queryParams: { numeroPedido: this.data.idPedido } }));
                    }
                } else {
                    setTimeout(() => {
                        this.spinner.hide('default');
                        this.toastr.success('Status alterado com sucesso', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
                        this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
                            this.router.navigate(["/pages/consultar-pedidos"], { queryParams: { numeroPedido: this.data.idPedido } }));
                    }, 500);
                }
            });
        } catch (e) {

        };
    }

    autenticarSenha() {
        this.spinner.show('default');

        this.toastr.warning('Realizando autenticação', 'Status', { progressBar: true, positionClass: 'toast-top-center', });

        this.usuarioService.validarSenhaMaster(this.senhaMaster).then(resp => {
            this.toastr.clear();
            if (resp) {
                this.iniciarTabela();
            } else {
                this.bAutenticado = false;
                this.toastr.error('A senha informada não confere!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
                this.senhaMaster = '';
                document.getElementById('input_senha_master').focus();
            }
            setTimeout(() => this.spinner.hide('default'), 150);
        }).catch(err => {
            this.toastr.clear();
            this.toastr.error('Houve um erro ao validar sua permissão! Tente novamente!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
            setTimeout(() => this.spinner.hide('default'), 300);

        })
    }

    iniciarTabela() {
        this.copiaProdutos = this.data.produtos;
        this.produtosLista = this.data.produtos;
        this.produtosSource = this.data.produtos;
        this.copiaTotal = this.data.total;
        this.produtosSource = new MatTableDataSource(this.data.produtos);
        this.auxValorTotal = this.data.total;

        this.bAutenticado = true;

    }

    fechar() {
        this.dialogRef.close();
        this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
            this.router.navigate(["/pages/consultar-pedidos"], { queryParams: { numeroPedido: this.data.idPedido } }));
    }
}
